
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import MovieSearchProject from "./pages/MovieSearchProject";
import OnlineStoreProject from "./pages/OnlineStoreProject";
import ShoeStoreProject from "./pages/ShoeStoreProject";
import ResumePage from "./pages/ResumePage";
import ChatroomProject from "./pages/ChatroomProject";
import GameInterface from "./pages/GameInterface";

const queryClient = new QueryClient();

const App = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/projects/movie-search" element={<MovieSearchProject />} />
            <Route path="/projects/online-store" element={<OnlineStoreProject />} />
            <Route path="/projects/shoe-store" element={<ShoeStoreProject />} />
            <Route path="/projects/chatroom" element={<ChatroomProject />} />
            <Route path="/projects/game-interface" element={<GameInterface />} />
            <Route path="/resume" element={<ResumePage />} />
          </Routes>
        </TooltipProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
